const GatePassCards = ({ rows = [] }) => {
  return (
    <div className="card-table-container flex flex-col gap-[15px]">
      {rows.length === 0 ? (
        <p className="info-text text-center">No gate passes found</p>
      ) : (
        rows.map((row, idx) => (
          <div key={row._id || idx} className="border border-gray-300 rounded-lg p-6 w-full">
            <div className="detail-row mb-2">
              <div className="detail-column">
                <p className="detail-label">Unit</p>
                <p className="detail">{row.unit?.unitNumber || 'N/A'}</p>
              </div>
              <div className="detail-column">
              <p className="detail-label">Requested On</p>
              <p className="detail">
                {new Date(row.createdAt).toLocaleDateString()}
              </p>
            </div>
            </div>
            <div className="detail-column mb-5">
                <p className="detail-label">Status</p>
                <span className={`request-status-badge ${row.status?.toLowerCase()}`} style={{ display: 'flex', justifyContent: 'center' }}>
                  {row.status}
                </span>
              </div>

            <div className="detail-row">
              <div className="detail-column">
                <p className="detail-label">Start Date</p>
                <p className="detail">
                  {row.details?.startDate ? new Date(row.details.startDate).toLocaleDateString() : '—'}
                </p>
              </div>
              <div className="detail-column">
                <p className="detail-label">End Date</p>
                <p className="detail">
                  {row.details?.endDate ? new Date(row.details.endDate).toLocaleDateString() : '—'}
                </p>
              </div>
            </div>
            <div className="detail-column mb-2">
              <p className="detail-label">Description</p>
              <p className="detail">{row.description || 'N/A'}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default GatePassCards;
